// ----------------------------------------------------------------------
// <copyright file="Izenda.CrossFilterItem.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Cross Filtering Item Component
 */

import React, { PropTypes } from 'react';
import { observer } from 'mobx-react';
import ChartDrilldownBreadcrumb from 'modules/ReportDesigner/Fields/ReportBody/ReportPartType/Izenda.ChartDrilldownBreadcrumb';
import MapDrilldownBreadcrumb from 'modules/ReportDesigner/Fields/ReportBody/ReportPartType/Izenda.MapDrilldownBreadcrumb';
import ReportDesignerConstants from 'logic/data/Izenda.ReportDesignerConstants';
import { getOr } from 'lodash/fp';

const REPORT_PART_TYPE = ReportDesignerConstants.REPORT_PART_TYPE;
const PILL_COLOR = {
  LIGHT_BLUE: '#cee5f3',
  DARK_BLUE: '#b2cbdb'
};

const propTypes = {
  pill: PropTypes.object.isRequired,
  removeCrossFiltering: PropTypes.func,
  localization: PropTypes.object.isRequired,
  isLast: PropTypes.bool
};

const CrossFilterItem = observer(({ removeCrossFiltering, pill, localization, isLast }) => {
  const reportPart = getOr({}, 'reportPart', pill);
  const tooltip = getOr('', 'tooltip', pill);
  const alternative = getOr(false, 'alternative', pill);

  const reportPartName = getOr('', 'headerTitle', reportPart);
  const reportPartType = getOr(null, 'type', reportPart);
  const Drill = (function() {
    switch (reportPartType) {
      case REPORT_PART_TYPE.Chart:
      case REPORT_PART_TYPE.Gauge:
        return ChartDrilldownBreadcrumb;
      case REPORT_PART_TYPE.Map:
        return MapDrilldownBreadcrumb;
      default:
        return null;
    }
  })();

  const style = {
    backgroundColor: alternative ? PILL_COLOR.DARK_BLUE : PILL_COLOR.LIGHT_BLUE
  };

  return (
    <div className="izenda-CrossFiltering__CrossFilteringItem u-posRelative" style={style}>
      <div className="overflow-text">
        <strong title={tooltip}>{reportPartName}</strong>:
        {Drill && (
          <Drill
            reportPart={reportPart}
            hideAllLevel
            onDrillDown={reportPart.onDrilldown}
            className="izenda-CrossFiltering__Drill"
          />
        )}
        <a
          className="icon-cancel icon-removeCrossFilteringItem"
          title={localization.getText('CROSSFILTERING_REMOVE_TOOLTIP')}
          onMouseDown={removeCrossFiltering.bind(null, pill, isLast)}
          onTouchStart={removeCrossFiltering.bind(null, pill, isLast)}
        />
      </div>
    </div>
  );
});

CrossFilterItem.propTypes = propTypes;

export default CrossFilterItem;



// WEBPACK FOOTER //
// ./ui/modules/CrossFiltering/Izenda.CrossFilterItem.js